import AdminEmails from '@Containers/Emails/AdminEmails';

const AdminEmailsPage: React.FunctionComponent = (): JSX.Element => (
  <AdminEmails />
);

export default AdminEmailsPage;
